import { BaseResourceModel } from "../../models/base-resource.model";

export class FavorecidoCbo extends BaseResourceModel {
    constructor(
        public id?: number,
        public cbo?: string,
        public descricao?: string,
        public nivel?: number,
    ) {
        super();
    }
    static converteJson(json: any): FavorecidoCbo {
        return Object.assign(new FavorecidoCbo(), json);
    }
}